import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-883acd30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "storage-modal-title" }, "Add storage", -1))
const _hoisted_2 = {
  key: 0,
  class: "storage-modal-content"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "storage-header" }, " How much storage would you need? You can always add more if you need. ", -1))
const _hoisted_4 = { class: "storage-options" }
const _hoisted_5 = ["value", "onUpdate:modelValue"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "storage-pricing-note" }, "All prices are billed annually.", -1))
const _hoisted_7 = {
  key: 0,
  class: "storage-error"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "thank-you"
}

import { Constants } from "@/classes/constants";
import { Utils } from "@/classes/utils/utils";
import { useDataStore } from "@/store/data-store";
import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StorageRequestDialog',
  setup(__props, { expose }) {

const dataStore = useDataStore();
const storagePlans = Object.entries(Constants.storagePlans);

let data = reactive({
  show: false,
  isError: false,
  storageAmount: storagePlans[0]?.[0] ?? "",
  isSubmitted: false,
});

async function send() {
  if (!data.storageAmount) return;
  
  const message = `I would like to request ${data.storageAmount} storage`;
  
  const result = await dataStore.sendFeedback(window.location.href, message);
  if (!result) {
    data.isError = true;
    return;
  }
  
  data.isSubmitted = true;
  await Utils.delay(3000);
  hide();
}

function show() {
  data.show = true;
  data.isSubmitted = false;
  data.storageAmount = storagePlans[0]?.[0] ?? "";
  data.isError = false;
}

function hide() {
  data.show = false;
}

expose({ show });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (_unref(data).show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-dialog-bg d-flex align-items-center justify-content-center",
            onClick: hide
          }, [
            _createElementVNode("div", {
              class: "modal-main",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _hoisted_1,
              (!_unref(data).isSubmitted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storagePlans), ([storageAmount, price]) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: storageAmount,
                          class: _normalizeClass(["storage-option", { selected: _unref(data).storageAmount === storageAmount }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: storageAmount,
                            "onUpdate:modelValue": ($event: any) => ((_unref(data).storageAmount) = $event)
                          }, null, 8, _hoisted_5), [
                            [_vModelRadio, _unref(data).storageAmount]
                          ]),
                          _createTextVNode(" " + _toDisplayString(storageAmount) + " — " + _toDisplayString(price), 1)
                        ], 2))
                      }), 128))
                    ]),
                    _hoisted_6,
                    (_unref(data).isError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Error sending request, please try again later. "))
                      : _createCommentVNode("", true),
                    _hoisted_8,
                    _createElementVNode("div", { class: "storage-buttons" }, [
                      _createElementVNode("button", {
                        class: "btn-cancel",
                        onClick: hide
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "btn-send",
                        onClick: send
                      }, "Send Request")
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("h3", _hoisted_9, " Thank you for your request. "))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})